
class quickViewPopup {
  constructor() {  
    console.log('product card loaded');  
    this.init();
  }
  init = () => {
    this.quickView();
    this.imageSlider();
    
  }
  imageSlider= () => {
    const blockSlider = new Swiper('.quick-images-wrapper-js', {
      pagination: {
        el: ".quick-view-popup .swiper-pagination",
        clickable: true,
      },
       navigation: {
        nextEl: ".quick-images-wrapper-js .swiper-button-next",
        prevEl: ".quick-images-wrapper-js .swiper-button-prev",
      },
      slidesPerView: 1,  
      spaceBetween: 10,
      breakpoints: {
        325: {
            slidesPerView: 1,
            spaceBetween: 24
        },
        1024: {
            slidesPerView: 1,  
            spaceBetween: 10
        }     
      }
    });
  }
  quickView = () => {
    let quickViewModal = document.querySelectorAll('.quick-view-popup-js');
    quickViewModal && quickViewModal.length > 0 && quickViewModal.forEach(modal => {
      let AddToCartBtn = modal.querySelector('.add-to-cart-btn-js');
      AddToCartBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        let formData = {
          "id": 43798737584228,
          "quantity": 1
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        })
        .then(response => {
          alert('Item added to cart!');
          window.addToCart();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      });
      
      let closeBtn = modal.querySelector('.close-btn-js');
      closeBtn?.addEventListener('click',(e) =>{
        modal.style.display = 'none';
        document.querySelector('body').classList.remove('overflow-hidden');
      })
      let close = modal.querySelectorAll('.quick-bg-js');
      close && close.length>0 && close.forEach(btn => {
        btn?.addEventListener('click',(e) =>{
          modal.style.display = 'none';
          document.querySelector('body').classList.remove('overflow-hidden');
        })
      })
      

      let readMoreBtn = modal.querySelector('.read-more-button-js');
      let readLessBtn = modal.querySelector('.read-less-button-js');
      let fullDesc = modal.querySelector('.full-description-js');
      let smallDesc = modal.querySelector('.small-description-js');
      readMoreBtn?.addEventListener('click',(e) => {
        smallDesc?.classList.add('hide');
        fullDesc?.classList.remove('hide');
        readMoreBtn?.classList.add('hide');
        readLessBtn?.classList.remove('hide');
      })
      readLessBtn?.addEventListener('click',(e) => {
        fullDesc?.classList.add('hide');
        smallDesc?.classList.remove('hide');
        readLessBtn?.classList.add('hide');
        readMoreBtn?.classList.remove('hide');
      })
    })
  }
}
class productCardNew {
  constructor() {  
    console.log('product card loaded');  
    this.init();
  }
  init = () => {
    this.productCardFunc();
  }
  productCardFunc = () => {
    // Event delegation: works for product cards already in the DOM and for ones
    // injected later (e.g. PDP related products via dynamic-recommendations).
    document.addEventListener('click', (e) => {
      const previewButton = e.target.closest('.preview-button');
      if (!previewButton || !previewButton.dataset.prodUrl) return;
      e.preventDefault();
      const quickViewPopupEl = document.querySelector('.quick-view-popup-js');
      if (!quickViewPopupEl) return;
      fetch(previewButton.dataset.prodUrl)
        .then(response => response.text())
        .then(html => {
          quickViewPopupEl.innerHTML = html;
          quickViewPopupEl.style.display = 'block';
          document.querySelector('body').classList.add('overflow-hidden');
          new quickViewPopup();
        })
        .catch(error => {
          console.error('Error fetching product data:', error);
        });
    });
  }
}
new productCardNew();
window.productCardNew = () => {
  new productCardNew();
}
